import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-masterdata',
  templateUrl: './edit-masterdata.component.html',
  styleUrls: ['./edit-masterdata.component.css']
})
export class EditMasterdataComponent implements OnInit {

  constructor() {
    /**/
  }

  ngOnInit() {
    /**/
  }

}
